import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSitePreviewPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 368 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 368,
		height: 160,
		fill: "#E4E6F8"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M160.667 110C158.833 110 157.264 109.347 155.958 108.042C154.653 106.736 154 105.167 154 103.333V56.6667C154 54.8333 154.653 53.2639 155.958 51.9583C157.264 50.6528 158.833 50 160.667 50H207.333C209.167 50 210.736 50.6528 212.042 51.9583C213.347 53.2639 214 54.8333 214 56.6667V103.333C214 105.167 213.347 106.736 212.042 108.042C210.736 109.347 209.167 110 207.333 110H160.667ZM164 96.6667H204L191.5 80L181.5 93.3333L174 83.3333L164 96.6667ZM172.333 73.3333C173.722 73.3333 174.903 72.8472 175.875 71.875C176.847 70.9028 177.333 69.7222 177.333 68.3333C177.333 66.9444 176.847 65.7639 175.875 64.7917C174.903 63.8194 173.722 63.3333 172.333 63.3333C170.944 63.3333 169.764 63.8194 168.792 64.7917C167.819 65.7639 167.333 66.9444 167.333 68.3333C167.333 69.7222 167.819 70.9028 168.792 71.875C169.764 72.8472 170.944 73.3333 172.333 73.3333Z",
		fill: "white"
	})]
});
export default SvgSitePreviewPlaceholder;
